import { h } from "preact";
import "../style.css";
import ContentCard from "./ContentCard";
import InvalidCard from "./InvalidCard";
import { useState, useEffect } from "preact/hooks";
import Cookies from "js-cookie";
import { calculateForeground } from "../internal_utilities/utilities";

const Gift = props => {
  const [isVisible, setIsVisible] = useState(true);
  const [language, setLanguage] = useState("en");
  const [renderConfig, setRenderConfig] = useState(null);
  const [currentCampaign, setCurrentCampaign] = useState();
  const [isReferrerFlag, setIsReferrerFlag] = useState(false);
  const urlParams = new URLSearchParams(window.location.search);
  const currentCampaignId = urlParams.get("id");
  const referrerName = urlParams.get("name");
  const giftCode = urlParams.get("code");

  const getCurrentLangugeObject = selectedLanguage => {
    let langConfig = renderConfig.config.widgetConfig.langConfig.offerPage;
    let defaultLanguage =
      renderConfig.config.widgetConfig.langConfig.defaultLanguage;

    if (renderConfig && langConfig.hasOwnProperty(language))
      return langConfig[selectedLanguage];
    else return langConfig[defaultLanguage];
  };

  const wordReplacer = sourceText => {
    const dataMap = [
      {
        placeholder: "<gift_offer>",
        value: `${currentCampaign.giftConfig.discountValue * -1}${
          currentCampaign.giftConfig.discountType === "percentage"
            ? "%"
            : window.Shopify.currency.active
        }`
      },
      {
        placeholder: "<referrer_name>",
        value: `${referrerName.charAt(0).toUpperCase() + referrerName.slice(1)}`
      }
    ];
    let text = sourceText;
    dataMap.map(item => {
      text = text.replace(item.placeholder, `${item.value}`);
    });
    return text;
  };

  const config = {
    featureFlag: renderConfig && renderConfig.config.referral.featureFlag,
    simpleReferrals:
      renderConfig && renderConfig.config.referral.simpleReferrals
        ? renderConfig.config.referral.simpleReferrals
        : [],
    viralReferrals:
      renderConfig && renderConfig.config.referral.viralReferrals
        ? renderConfig.config.referral.viralReferrals
        : [],
    themeColors: {
      bgEndColor:
        renderConfig &&
        renderConfig.config.widgetConfig.commonConfig.bgEndColor,
      bgStartColor:
        renderConfig &&
        renderConfig.config.widgetConfig.commonConfig.bgStartColor,
      fgColor:
        renderConfig &&
        calculateForeground(
          renderConfig.config.widgetConfig.commonConfig.bgEndColor
        )
    },
    currentLanguage: renderConfig && getCurrentLangugeObject(language)
  };

  const setRefereeCookies = () => {
    Cookies.set(`discount_code`, giftCode, {
      expires: 2,
      sameSite: "lax",
      secure: true
    });
    Cookies.set(`ofco-gift-recipient`, true, {
      expires: 2,
      sameSite: "lax",
      secure: true
    });
  };

  useEffect(() => {
    // The task of setting values inside window.ofcoConfig is done in index.js right at the beginning of render
    if (window.ofcoConfig && currentCampaignId) {
      setRenderConfig(window.ofcoConfig);
      let simpleReferrals = window.ofcoConfig.config.referral.simpleReferrals ? window.ofcoConfig.config.referral.simpleReferrals : [];
      let viralReferrals = window.ofcoConfig.config.referral.viralReferrals ? window.ofcoConfig.config.referral.viralReferrals : [];
      let combinedCampaigns = [...simpleReferrals, ...viralReferrals]
      const campaign = combinedCampaigns.find(item => {
        if (item) {
          return item.campaignId === parseInt(currentCampaignId, 10);
        } else return false;
      });
      setCurrentCampaign(campaign);
      if (Cookies.get(`ofco-existing-referrer-${currentCampaignId}`))
        setIsReferrerFlag(true);
      else setRefereeCookies();
      window.Shopify.locale && setLanguage(window.Shopify.locale);
    }
  }, []);

  const getThemeColor = campaignType => {
    if (
      campaignType === "SIMPLE_REFERRAL" &&
      currentCampaign.thankyouPageConfig.giftPageColor
    )
      return currentCampaign.thankyouPageConfig.giftPageColor;
    else if (campaignType === "VIRAL_REFERRAL" && currentCampaign.giftPageColor)
      return currentCampaign.giftPageColor;
    else return "rgb(18,109,255)";
  };

  if (
    currentCampaignId &&
    currentCampaign &&
    window.location.pathname !== "/a/offers/gift"
  ) {
    return (
      // removing clean slate for the time being if required paste it below
      <div className="corner-midas-gift-popup">
        <style>
          {currentCampaign.thankyouPageConfig.widgetCustomCss &&
            currentCampaign.thankyouPageConfig.widgetCustomCss}
        </style>
        {isVisible && (
          <div className="corner-modal-wrapper fixed inset-0 flex items-center justify-center bg-black/50 z-50">
            {!isReferrerFlag ? (
              <ContentCard
                onClose={() => {
                  window.location = `/discount/${giftCode}`;
                  setIsVisible(false)
                }}
                color={getThemeColor(currentCampaign.type)}
                title={
                  config.currentLanguage.gift_share_page_title
                    ? wordReplacer(config.currentLanguage.gift_share_page_title)
                    : "Congrats you've been gifted a coupon code worth 12%"
                }
                giftCode={giftCode}
                // TODO : add this to i18n Config in falcon
                ctaText={
                  config.currentLanguage.share_modal_cta_text
                    ? config.currentLanguage.share_modal_cta_text
                    : "Continue Shopping"
                }
                copyText={
                  config.currentLanguage.copy_text
                    ? config.currentLanguage.copy_text
                    : "Copy Code"
                }
                explainertext={
                  config.currentLanguage.reward_share_page_description
                    ? config.currentLanguage.reward_share_page_description
                    : "The reward is automatically applied to this session. So you can purchase anything right now and the coupon discount will be already added in the cart. But if you want to use this code later or on an another device, copy the code below"
                }
              />
            ) : (
              <InvalidCard
                onClose={() => setIsVisible(false)}
                title={
                  config.currentLanguage.invalid_gift_share_modal_title
                    ? config.currentLanguage.invalid_share_modal_title
                    : "Invalid Gift URL"
                }
                explainertext={
                  config.currentLanguage.invalid_share_modal_description
                    ? config.currentLanguage.invalid_share_modal_description
                    : "The Gift coupon cannot be redeemed by the referrer for themselves"
                }
                color={getThemeColor(currentCampaign.type)}
                ctaText={
                  config.currentLanguage.invalid_modal_cta_text
                    ? config.currentLanguage.invalid_modal_cta_text
                    : "Continue Shopping"
                }
              />
            )}
          </div>
        )}
      </div>
    );
  }
};

export default Gift;
